import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import AppRoutes from './routes/AppRoutes';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { UIProvider } from './context/UIContext';
import UnauthorizedListener from './components/layout/UnauthorizedListener';
import './styles/global.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <UIProvider>
          <AuthProvider>
            <CartProvider>
              {/* Listens for any 401 from RTK Query — clears session + bounces to /login */}
              <UnauthorizedListener />
              <AppRoutes />
            </CartProvider>
          </AuthProvider>
        </UIProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
